import { GenericHeader, SearchBar } from 'components';
import ListComp from 'components/ListComp';
import React from 'react';
import { Student } from 'services';
import { Results } from './components';
import { curriculum_manager } from 'utils/constants';
import { useSelector } from 'react-redux';

const UserModuleList = props => {
  const model = useSelector(state => state.models.student);

  const Head = props => {
    let { handleCreateOpen, ...rest } = props; // eslint-disable-line
    return (
      <GenericHeader header="All User Modules" subheader="User Module Management" {...rest} />
    );
  }

  return (
    <ListComp
      listing={Student.module}
      title="User Modules"
      name="user_modules"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      roles={[curriculum_manager]}
      params={{ student_id: model.id }}
      filters={{ limit: 10, offset: 0, count: 0, search: "", type: "" }}
    />
  );
};

export default UserModuleList;
